import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import SideBar from "./SideBar";
import TopBar from "./TopBar";
import {
  contentWrapperSx,
  mainLayoutSx,
  outletBoxSx,
} from "styles/layouts/MainLayout.styles";
import { useStore } from "stores/useStore";
import { useEffect } from "react";
import { getSocket, initSocket } from "services/socket.service";

const MainLayout = () => {
  const { authStore } = useStore();

  useEffect(() => {
    if (authStore.user?.companyId) {
      initSocket(authStore.user.companyId);
    }

    return () => {
      try {
        getSocket()?.disconnect();
      } catch (err) {
        // console.log("Socket not initialized");
      }
    };
  }, [authStore.user?.companyId]);
  
  return (
    <Box sx={mainLayoutSx}>
      <SideBar />
      <Box sx={contentWrapperSx}>
        <TopBar />
        <Box sx={outletBoxSx}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default MainLayout;
